import React from 'react';

export default function Sonna(){
    return (
        <div>
            طور الإنشاء...
        </div>
    )
}